import PaginationParameters from "_shared/_api/queries/pagination/pagination-parameters";
import { Query } from "_shared/_api/queries/query";
import { FeeScheduleTemplateOrderParameters } from "work/fee-schedule-templates/_api/queries/contracts/ordering/fee-schedule-template-order-parameters";
import { FeeScheduleTemplateFilterParameters } from "work/fee-schedule-templates/_api/queries/contracts/filtering/fee-schedule-template-filter-parameters";
import FeeScheduleTemplateQuerySchema, { FeeScheduleTemplateQueryJSON, FeeScheduleTemplateQueryParams } from "work/fee-schedule-templates/_api/queries/_schema/fee-schedule-template-query-schema";

export default class FeeScheduleTemplateQuery extends Query<
  FeeScheduleTemplateFilterParameters,
  FeeScheduleTemplateOrderParameters,
  PaginationParameters
> {
  public static fromJSON(json: FeeScheduleTemplateQueryJSON): FeeScheduleTemplateQuery {
    if (!json) return json;
    const parsed = FeeScheduleTemplateQuerySchema.deserialize(json);
    return new FeeScheduleTemplateQuery(parsed);
  }

  public constructor(params: FeeScheduleTemplateQueryParams) {
    super({
      filterParameters: new FeeScheduleTemplateFilterParameters(params.filterParameters),
      orderParameters: new FeeScheduleTemplateOrderParameters(params.orderParameters),
      paginationParameters: PaginationParameters.create(params.paginationParameters),
    });
  }

  public toJSON(): FeeScheduleTemplateQueryJSON {
    return FeeScheduleTemplateQuerySchema.serialize(this);
  }

  public isEqualTo(other: FeeScheduleTemplateQuery): boolean {
    if (!other || !(other instanceof FeeScheduleTemplateQuery)) {
      return false;
    }
    return (
      this.filterParameters.isEqualTo(other.filterParameters) &&
      this.orderParameters.isEqualTo(other.orderParameters) &&
      this.paginationParameters.isEqualTo(other.paginationParameters)
    );
  }
}
